import RightHeaderContainer from './RightHeaderContainer';

export default RightHeaderContainer;